import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const routes: RouteRecordRaw[] = [
  { path: '/login', component: () => import('../views/LoginView.vue'), meta: { public: true } },
  { path: '/register', component: () => import('../views/RegisterView.vue'), meta: { public: true } },
  { path: '/admin/login', component: () => import('../views/LoginView.vue'), props: { admin: true }, meta: { public: true } },
  { path: '/', component: () => import('../views/DashboardView.vue'), meta: { userOnly: true, navKey: 'user-overview' } },
  { path: '/dicom', component: () => import('../views/BatchListView.vue'), props: { module: 'dicom' }, meta: { userOnly: true, navKey: 'user-dicom' } },
  { path: '/dicom/upload', component: () => import('../views/BatchUploadView.vue'), props: { module: 'dicom' }, meta: { userOnly: true, navKey: 'user-dicom' } },
  { path: '/dicom/batches/:id', component: () => import('../views/BatchDetailView.vue'), props: (route) => ({ module: 'dicom', id: route.params.id }), meta: { navKey: 'user-dicom' } },
  { path: '/dicom/batches/:batchId/items/:itemId', component: () => import('../views/DicomBatchItemView.vue'), props: true, meta: { navKey: 'user-dicom' } },
  { path: '/pdf', component: () => import('../views/BatchListView.vue'), props: { module: 'pdf' }, meta: { userOnly: true, navKey: 'user-pdf' } },
  { path: '/pdf/upload', component: () => import('../views/BatchUploadView.vue'), props: { module: 'pdf' }, meta: { userOnly: true, navKey: 'user-pdf' } },
  { path: '/pdf/batches/:id', component: () => import('../views/BatchDetailView.vue'), props: (route) => ({ module: 'pdf', id: route.params.id }), meta: { navKey: 'user-pdf' } },
  { path: '/image-convert', component: () => import('../views/ImageConvertRecordsView.vue'), meta: { userOnly: true, navKey: 'user-image-convert' } },
  { path: '/image-convert/new', component: () => import('../views/ImageConvertUploadView.vue'), meta: { userOnly: true, navKey: 'user-image-convert' } },
  { path: '/image-convert/:id', component: () => import('../views/ImageConvertDetailView.vue'), props: true, meta: { navKey: 'user-image-convert' } },
  { path: '/account', component: () => import('../views/AccountView.vue'), meta: { navKey: 'account' } },
  { path: '/admin', component: () => import('../views/admin/AdminOverviewView.vue'), meta: { adminOnly: true, navKey: 'admin-overview' } },
  { path: '/admin/users', component: () => import('../views/admin/AdminUsersView.vue'), meta: { adminOnly: true, navKey: 'admin-users' } },
  { path: '/admin/dicom', component: () => import('../views/admin/AdminDicomView.vue'), meta: { adminOnly: true, navKey: 'admin-dicom' } },
  { path: '/admin/pdf', component: () => import('../views/admin/AdminPdfView.vue'), meta: { adminOnly: true, navKey: 'admin-pdf' } },
  { path: '/admin/tasks', component: () => import('../views/admin/AdminTasksView.vue'), meta: { adminOnly: true, navKey: 'admin-tasks' } },
  { path: '/admin/logs', component: () => import('../views/admin/AdminLogsView.vue'), meta: { adminOnly: true, navKey: 'admin-logs' } },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.ready) await auth.restore()
  if (to.meta.public) {
    if (auth.isAuthenticated) return auth.isAdmin ? '/admin' : '/'
    return true
  }
  if (!auth.isAuthenticated) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  if (to.meta.adminOnly && !auth.isAdmin) return '/'
  if (to.meta.userOnly && auth.isAdmin) return '/admin'
  return true
})
